/* eslint-disable camelcase */
import React from 'react';
import { jsx as ___EmotionJSX } from "@emotion/react";
export var totalFuturePaymentsBreakdownColumns = [{
  name: 'Кр. посредник',
  value: 'franchisee_name',
  width: '110px'
}, {
  name: 'Офис',
  value: 'office_name',
  width: '110px',
  sm: true
}, {
  name: 'Общо непадеж. главници',
  render: function render(_ref) {
    var total_principal = _ref.total_principal,
        currency = _ref.currency;
    return ___EmotionJSX("span", {
      "data-value": "total_principal"
    }, total_principal, " ", currency);
  }
}, {
  name: 'Общо очакв. лихви',
  render: function render(_ref2) {
    var total_interests = _ref2.total_interests,
        currency = _ref2.currency;
    return ___EmotionJSX("span", {
      "data-value": "total_interests"
    }, total_interests, " ", currency);
  },
  md: true
}, {
  name: 'Общо очакв. такси',
  render: function render(_ref3) {
    var total_fees = _ref3.total_fees,
        currency = _ref3.currency;
    return ___EmotionJSX("span", {
      "data-value": "total_fees"
    }, total_fees, " ", currency);
  },
  md: true
}, {
  name: 'Общо',
  render: function render(_ref4) {
    var total = _ref4.total,
        currency = _ref4.currency;
    return ___EmotionJSX("span", {
      "data-value": "total"
    }, total, " ", currency);
  }
}];